import { EBaseButtonType } from '@spinwise/react-component-library/ButtonAbstract';

export enum EBrandButtonTypes {
  Navigation = 'btn-type--navigation',
  NavigationActive = 'btn-type--navigation-active',
  Bonuses = 'btn-type--bonuses',
  ReadMore = 'btn-type--readmore',
  SeeTerms = 'btn-type--see-terms',
  MessageDelete = 'btn-type--message-delete',
  MessageDeletePlain = 'btn-type--message-delete-plain',
  NotificationDelete = 'btn-type--notification-delete',
  Neutral = 'btn-type--neutral',
  NeutralWhite = 'btn-type--neutral-white',
  TopNav = 'btn-type--top-nav',
  TopNavHover = 'btn-type--top-nav-hover',
  TopNavActive = 'btn-type--top-nav-active',

  TopNavB = 'btn-type--top-nav-b',
  TopNavHoverB = 'btn-type--top-nav-hover-b',
  TopNavActiveB = 'btn-type--top-nav-active-b',

  HomepageNav = 'btn-type--homepage-nav',
  HomepageNavHover = 'btn-type--homepage-nav-hover',
  HomepageNavActive = 'btn-type--homepage-nav-active',
  //
  SuperchargeLocked = 'btn-type--supercharge-btn-locked',
  SuperchargeBtn = 'btn-type--supercharge-btn',
  SuperchargeBtnHover = 'btn-type--supercharge-btn-hover',
  SuperchargeBtnActive = 'btn-type--supercharge-btn-active',
  Caution = 'btn-type--cautioun',
  Pagination = 'btn-type--pagination',
  // header nav
  HeaderNav = 'btn-type--header-nav',
  HeaderNavHover = 'btn-type--header-nav-hover',
  HeaderNavActive = 'btn-type--header-nav-active',

  FavoriteBtnActive = 'btn-type--favorite-btn-active',
  AccountNav = 'btn-type--account-nav',
  AccountNavHover = 'btn-type--account-nav-hover',
  AccountNavActive = 'btn-type--account-nav-active',
  AccountNavVip = 'btn-type--account-nav-vip',
  AccountNavVipActive = 'btn-type--account-nav-vip-active',
  CTA = 'btn-type--cta',
  Secondary = 'btn-type--brand-secondary',
  SecondaryInverted = 'btn-type--brand-secondary-inverted',
  Tertiary = 'btn-type--tertiary',

  MobileLanguage = 'btn-type--mobile-language',
  Informative = 'btn-type--informative',

  ExternalLink = 'btn-type--external-link',
  ExternalLinkDark = 'btn-type--external-link-dark',

  Disabled = 'btn-type--disabled',
  DisabledSecond = 'btn-type--disabled-second',
  KeyboardButton = 'btn-type--keyboard-btn',
  KeyboardButtonLight = 'btn-type--keyboard-btn--light',

  KeyboardCancel = 'btn-type--keyboard-cancel',
  KeyboardCancelLight = 'btn-type--keyboard-cancel--light',
  ResetSearch = 'btn-type--reset-search',
  BrandAlpha50 = 'btn-type--brand-alpha-50',

  PromotionSwitcher = 'btn-type--promotion-switcher',
  PromotionSwitcherActive = 'btn-type--promotion-switcher-active',
  Alpha10Alpha30 = 'btn-type--alpha-10-alpha-30',
  Done = 'btn-type--done',
  PrimaryActive = 'btn-type--primary-active',
  InheritColor = 'btn-type--inherit-color',
  LockedBonuses = 'btn-type--locked-bonuses',

  Primary = 'btn-type--primary',
}

export const ButtonLibrary = {
  ...EBrandButtonTypes,
  ...EBaseButtonType,
};
